"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shallowEquals_1 = require("./shallowEquals");
function shallowMerge(a, b) {
    var result = Object.assign({}, a, b);
    return shallowEquals_1.shallowEquals(a, result) ? a : result;
}
exports.shallowMerge = shallowMerge;
